// setShouldSubmitStreamPaymentOnSdPreset.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should submit stream payment on sd preset
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {string} {sessionId} - session id.
 * @param {boolean} {shouldSubmitStreamPaymentOnSdPreset} - flag value.
 * @return {Promise} Action promise.
 */
const setShouldSubmitStreamPaymentOnSdPreset =
  ({ streamId, sessionId, shouldSubmitStreamPaymentOnSdPreset }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream', 'paid', streamId, sessionId],
        data: {
          shouldSubmitStreamPaymentOnSdPreset:
            !!shouldSubmitStreamPaymentOnSdPreset,
        },
      },
    });
  };

export default setShouldSubmitStreamPaymentOnSdPreset;
